import { useAppSelector } from "@/store";
import { useAuthState } from "@/store/auth";
import { RotasEnum } from "@/utils/rotas";
import { Loader } from "lucide-react";
import { Navigate, Outlet } from "react-router";

export default function AuthLayout() {
    const {logado} = useAppSelector(useAuthState)

    if(logado) {
        return <Navigate to={RotasEnum.PAINEL} />
    }


    return (
        <div 
            className="w-dvw h-dvh flex flex-1 items-center justify-center bg-slate-900 px-2 bg-cover bg-center" 
            style={{ backgroundImage: 'url(https://placehold.co/1600x900.png)' }}
        >
            <Outlet/>
            <Loader />
        </div>
    )
}